export default {
    getters: {
        optionsLocationType: () => {
            return [
                {label: 'Longue durée', value: 'Longue durée'},
                {label: 'Courte durée', value: 'Courte durée'},
                {label: 'Location nue', value: 'Location nue'},
                {label: 'Colocation',  value: 'Colocation'},
                {label: 'Résidence de service', value: 'Résidence de service'},
                {label: 'Mobil home',   value: 'Mobil home'},
            ]
        },

        optionsForfaitTravaux: () => {
            return [
                { value: 0, label: 'Non' },
                { value: 1, label: 'Oui année N' },
                { value: 2, label: 'Oui année N+1'}
            ]
        },
    }
}
